import {
    LOGIN_SUCCEEDED,
    LOGIN_API_MESSAGES_SHOW, LOGIN_SUCCEEDED_GUEST
} from '../actions/types';

const initialState = {
    token: {},
    login_type: {},
    errors: {}
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOGIN_SUCCEEDED_GUEST:
        case LOGIN_SUCCEEDED:
            return {
                ...state,
                token: action.payload.access_token,
                login_type: action.payload.user_roles[0]
            };

        case LOGIN_API_MESSAGES_SHOW:
            return {
                ...state,
                errors: action.payload
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/SHARED/reducers/user.reducer.js